import { API } from "@/App";

/** Renders an image stored in object storage by its path. */
export const ListingImage = ({ path, alt = "", className = "" }) => {
  if (!path) {
    return (
      <div className={`bg-slate-800 flex items-center justify-center ${className}`}>
        <span className="text-slate-600 text-xs">no image</span>
      </div>
    );
  }
  return (
    <img
      src={`${API}/uploads/${path}`}
      alt={alt}
      loading="lazy"
      className={className}
    />
  );
};
